import React from 'react';
import { AsyncDisplay, LoadingMessage } from 'js/components';
import { Redirect, Route, Switch } from 'react-router';
import OrgRecommendations from './Visualizations/OrgRecommendations';
import SquadScorecard from './Visualizations/SquadScorecard';
import OrgTrends from './Visualizations/OrgTrends';
import OrgAnalyze from './Visualizations/OrgAnalyze/OrgAnalyze';

function OrgComponentDetailRouter({
  questionScoresQuery,
  orgRubricScoresQuery,
  orgTrendsQuery,
  match,
  organization,
  workspace,
  templates,
  rubricTemplate = null,
  isRubric = false,
}) {
  const effectiveTemplates =
    isRubric && rubricTemplate ? [rubricTemplate] : templates;
  return (
    <AsyncDisplay
      isLoading={questionScoresQuery.query?.isLoading ?? true}
      isError={!!questionScoresQuery.query?.error}
    >
      <AsyncDisplay.Loading>
        <LoadingMessage iconSize="2x">Loading &hellip;</LoadingMessage>
      </AsyncDisplay.Loading>
      <AsyncDisplay.Error>
        <div>Sorry, there was a problem loading the details.</div>
      </AsyncDisplay.Error>
      <AsyncDisplay.Resolved>
        <Switch>
          <Route
            path={`${match.path}/recommendations/:subOrgId?`}
            exact
            render={({ match: childMatch, ...routeProps }) => (
              <OrgRecommendations
                {...routeProps}
                match={{
                  ...match,
                  params: { ...match.params, ...childMatch.params },
                }}
                workspace={workspace}
                organization={organization}
                questionScores={questionScoresQuery.data}
                catalog={questionScoresQuery.catalog}
                assessmentKey={match.params.assessmentKey}
                templates={effectiveTemplates}
              />
            )}
          />
          <Route
            path={`${match.path}/squad-scorecard`}
            exact
            render={() => (
              <SquadScorecard
                workspace={workspace}
                organization={organization}
                questionScores={questionScoresQuery.data}
                assessmentKey={match.params.assessmentKey}
                templates={effectiveTemplates}
              />
            )}
          />
          <Route
            path={`${match.path}/org-trends/:subOrgId?`}
            exact
            render={({ match: childMatch, history, location }) => {
              const trendsQuery = isRubric
                ? orgRubricScoresQuery
                : orgTrendsQuery;
              const trendsLoading = Boolean(
                trendsQuery?.query?.isLoading ||
                  (!trendsQuery?.data && !trendsQuery?.query?.error)
              );

              return (
                <OrgTrends
                  history={history}
                  location={location}
                  match={{
                    ...match,
                    params: { ...match.params, ...childMatch.params },
                  }}
                  isRubric={isRubric}
                  orgRubricScores={orgRubricScoresQuery?.data}
                  nativeTrends={orgTrendsQuery?.data}
                  rubricDocument={orgRubricScoresQuery?.data?.document}
                  assessmentTemplate={
                    isRubric
                      ? rubricTemplate
                      : templates?.find(
                          ({ key }) => key === match.params.assessmentKey
                        )
                  }
                  organization={organization}
                  workspace={workspace}
                  loading={trendsLoading}
                  error={trendsQuery?.query?.error}
                />
              );
            }}
          />
          <Route
            path={`${match.path}/analyze`}
            exact
            render={({ location }) => (
              <Redirect
                to={{
                  pathname: `${match.url}/insights`,
                  search: location.search,
                }}
              />
            )}
          />
          <Route
            path={`${match.path}/insights`}
            exact
            render={() => (
              <OrgAnalyze
                workspace={workspace}
                organization={organization}
                assessmentKey={match.params.assessmentKey}
                isRubric={isRubric}
                assessmentTemplate={
                  isRubric
                    ? rubricTemplate
                    : templates?.find(
                        ({ key }) => key === match.params.assessmentKey
                      )
                }
              />
            )}
          />
          <Route
            path={match.path}
            exact
            render={() => <Redirect to={`${match.url}/recommendations`} />}
          />
        </Switch>
      </AsyncDisplay.Resolved>
    </AsyncDisplay>
  );
}

export default OrgComponentDetailRouter;
